import { render, staticRenderFns } from "./ClassroomView.vue?vue&type=template&id=e9a6c842"
import script from "./ClassroomView.vue?vue&type=script&lang=js"
export * from "./ClassroomView.vue?vue&type=script&lang=js"
import style0 from "./ClassroomView.vue?vue&type=style&index=0&id=e9a6c842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports